"use strict";
// Many contexts will want to interact with the relevant react component. This
// will take a DOM element and return the React component that created it.
Object.defineProperty(exports, "__esModule", { value: true });
function componentForElement(el) {
    for (var key in el) {
        if (key.startsWith('__reactInternalInstance$')) {
            var fiberNode = el[key];
            return fiberNode && fiberNode.return && fiberNode.return.stateNode;
        }
    }
    if (el.parentElement) {
        return componentForElement(el.parentElement);
    }
}
exports.componentForElement = componentForElement;
;
//# sourceMappingURL=utils.js.map